import { outlinedInputClasses } from '@mui/material/OutlinedInput';
import { textFieldClasses } from '@mui/material/TextField';

import type { Theme } from '../types';
import type { Components } from '@mui/material/styles';

export const MuiAutocomplete = {
  defaultProps: {},
  styleOverrides: {
    root: {
      padding: '0px',
      [`& .${outlinedInputClasses.root}`]: {
        paddingTop: '0px',
        paddingBottom: '0px',
        [`& .MuiAutocomplete-endAdornment`]: {
          right: '0px',
          top: '50%',
          transform: 'translateY(-50%)',
        },
      },
      [`& .${textFieldClasses.root}`]: {
        [`& .MuiAutocomplete-endAdornment`]: {
          right: '0px',
          top: '50%',
          transform: 'translateY(-50%)',
        },
      },
    },
    input: {
      height: 'auto',
      padding: 0,
    },
  },
} satisfies Components<Theme>['MuiAutocomplete'];
